import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { store, persistor } from "./components/Store/Store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";

import "@mantine/dates/styles.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MantineProvider>
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </MantineProvider>
  </React.StrictMode>
);

reportWebVitals();
